exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "img[data-v-9c9082f0]{max-width:none!important}.centered-image[data-v-9c9082f0]{display:none;opacity:0;transition:all .4s}.centered-image.loaded[data-v-9c9082f0]{opacity:1}", ""]);

